import { useAdvancedFormContext } from "../advanced-form";
import { Button } from "antd";

function FormItemButton({ readOnly, disabled, label, value, onChange, typeData }: any) {
  const advancedFormContext = useAdvancedFormContext()
  const effectiveReadOnly = readOnly || advancedFormContext?.readOnly

  return (
    <>
      <Button disabled={effectiveReadOnly} onClick={typeData?.onClick || (() => {})}>{ typeData?.caption }</Button>
    </>
  )
}

export default FormItemButton;